module.exports = __webpack_public_path__ + "static/img/wall-conveyor-x1_256.e14dbc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wall-conveyor-x1_256.png
// module id = NJC2
// module chunks = 0